define("ember-power-select/components/power-select", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@glimmer/tracking", "@ember/object", "@ember/object/observers", "@ember/runloop", "@ember/utils", "@ember/debug", "ember-power-select/utils/group-utils", "ember-concurrency-decorators", "ember-concurrency"], function (_exports, _component, _templateFactory, _component2, _tracking, _object, _observers, _runloop, _utils, _debug, _groupUtils, _emberConcurrencyDecorators, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <BasicDropdown
    @horizontalPosition={{@horizontalPosition}}
    @destination={{@destination}}
    @initiallyOpened={{@initiallyOpened}}
    @matchTriggerWidth={{this.matchTriggerWidth}}
    @preventScroll={{or @preventScroll false}}
    @onClose={{this.handleClose}}
    @onOpen={{this.handleOpen}}
    @renderInPlace={{@renderInPlace}}
    @verticalPosition={{@verticalPosition}}
    @disabled={{@disabled}}
    @calculatePosition={{@calculatePosition}}
    @triggerComponent={{ensure-safe-component @ebdTriggerComponent}}
    @contentComponent={{ensure-safe-component @ebdContentComponent}}
    as |dropdown|>
    {{#let (assign dropdown (hash
      selected=this.selected
      highlighted=this.highlighted
      options=this.options
      results=this.results
      resultsCount=this.resultsCount
      loading=this.loading
      isActive=this.isActive
      searchText=this.searchText
      lastSearchedText=this.lastSearchedText
      actions=(assign dropdown.actions this._publicAPIActions)
    )) (concat "ember-power-select-options-" dropdown.uniqueId) as |publicAPI listboxId|}}
      <dropdown.Trigger
        @eventType={{or @eventType "mousedown"}}
        {{did-insert this._updateOptions @options}}
        {{did-update this._updateOptions @options}}
        {{did-insert this._updateSelected @selected}}
        {{did-update this._updateSelected @selected}}
        {{did-insert this._registerAPI publicAPI}}
        {{did-update this._registerAPI publicAPI}}
        {{did-update this._performSearch this.searchText}}
        {{on "keydown" this.handleTriggerKeydown}}
        {{on "focus" this.handleFocus}}
        {{on "blur" this.handleBlur}}
        class="ember-power-select-trigger {{@triggerClass}}{{if publicAPI.isActive " ember-power-select-trigger--active"}}"
        aria-activedescendant={{if dropdown.isOpen (unless @searchEnabled (concat publicAPI.uniqueId "-" this.highlightedIndex))}}
        aria-controls={{unless @searchEnabled listboxId}}
        aria-describedby={{@ariaDescribedBy}}
        aria-haspopup={{unless @searchEnabled "listbox"}}
        aria-invalid={{@ariaInvalid}}
        aria-label={{@ariaLabel}}
        aria-labelledby={{@ariaLabelledBy}}
        aria-owns=""
        aria-required={{@required}}
        role={{or @triggerRole "button"}}
        title={{@title}}
        id={{@triggerId}}
        tabindex={{and (not @disabled) (or @tabindex "0")}}
        ...attributes
      >
        {{#let 
          (if 
            @triggerComponent 
            (component (ensure-safe-component @triggerComponent)) 
            (component 'power-select/trigger')
          ) 
        as |Trigger|}}
          <Trigger
            @allowClear={{@allowClear}}
            @buildSelection={{@buildSelection}}
            @loadingMessage={{or @loadingMessage "Loading options..."}}
            @selectedItemComponent={{ensure-safe-component @selectedItemComponent}}
            @select={{publicAPI}}
            @searchEnabled={{@searchEnabled}}
            @searchField={{@searchField}}
            @onFocus={{this.handleFocus}}
            @onBlur={{this.handleBlur}}
            @extra={{@extra}}
            @listboxId={{listboxId}}
            @onInput={{this.handleInput}}
            @onKeydown={{this.handleKeydown}}
            @placeholder={{@placeholder}}
            @placeholderComponent={{if 
              @placeholderComponent 
              (ensure-safe-component @placeholderComponent) 
              (component 'power-select/placeholder')
            }}
            @ariaActiveDescendant={{concat publicAPI.uniqueId "-" this.highlightedIndex}}
            as |opt term|>
            {{yield opt term}}
          </Trigger>
        {{/let}}
      </dropdown.Trigger>
      <dropdown.Content class="ember-power-select-dropdown{{if publicAPI.isActive " ember-power-select-dropdown--active"}} {{@dropdownClass}}">
        {{#if (not-eq @beforeOptionsComponent null)}}
          {{#let 
            (if 
              @beforeOptionsComponent 
              (component (ensure-safe-component @beforeOptionsComponent))
              (component 'power-select/before-options')
            ) 
          as |BeforeOptions|}}
            <BeforeOptions
              @select={{publicAPI}}
              @searchEnabled={{@searchEnabled}}
              @onInput={{this.handleInput}}
              @onKeydown={{this.handleKeydown}}
              @onFocus={{this.handleFocus}}
              @onBlur={{this.handleBlur}}
              @placeholder={{@placeholder}}
              @placeholderComponent={{or @placeholderComponent (component 'power-select/placeholder')}}
              @extra={{@extra}}
              @listboxId={{listboxId}}
              @ariaActiveDescendant={{concat publicAPI.uniqueId "-" this.highlightedIndex}}
              @selectedItemComponent={{ensure-safe-component @selectedItemComponent}}
              @searchPlaceholder={{@searchPlaceholder}}
            />
          {{/let}}
        {{/if}}
        {{#if this.mustShowSearchMessage}}
          {{#let 
            (if 
              @searchMessageComponent 
              (component (ensure-safe-component @searchMessageComponent))
              (component 'power-select/search-message')
            ) 
          as |SearchMessage|}}
            <SearchMessage @searchMessage={{this.searchMessage}} @select={{publicAPI}}/>
          {{/let}}
        {{else if this.mustShowNoMessages}}
          {{#let 
            (if 
              @noMatchesMessageComponent
              (component (ensure-safe-component @noMatchesMessageComponent))
              (component 'power-select/no-matches-message')
            ) 
           as |NoMatchesMessage|}}
            <NoMatchesMessage @noMatchesMessage={{this.noMatchesMessage}} @select={{publicAPI}} />
          {{/let}}
        {{else}}
          {{#let 
            (if 
              @optionsComponent
              (component (ensure-safe-component @optionsComponent))
              (component 'power-select/options')
            ) 
            (if 
              @groupComponent
              (component (ensure-safe-component @groupComponent))
              (component 'power-select/power-select-group')
            ) 
          as |Options Group|}}
            <Options
              @loadingMessage={{or @loadingMessage "Loading options..."}}
              @select={{publicAPI}}
              @options={{publicAPI.results}}
              @groupIndex=""
              @optionsComponent={{Options}}
              @extra={{@extra}}
              @highlightOnHover={{this.highlightOnHover}}
              @groupComponent={{Group}}
              id={{listboxId}}
              class="ember-power-select-options" as |option select|>
              {{yield option select}}
            </Options>
          {{/let}}
        {{/if}}
        
        {{#if @afterOptionsComponent}}
          {{#let (component (ensure-safe-component @afterOptionsComponent)) as |AfterOptions|}}
            <AfterOptions
              @extra={{@extra}}
              @select={{publicAPI}}
            />
          {{/let}}
        {{/if}}
      </dropdown.Content>
    {{/let}}
  </BasicDropdown>
  {{!-- <BasicDropdown
    @horizontalPosition={{@horizontalPosition}}
    @destination={{@destination}}
    @initiallyOpened={{@initiallyOpened}}
    @matchTriggerWidth={{this.matchTriggerWidth}}
    @preventScroll={{this.preventScroll}}
    @onClose={{this.handleClose}}
    @onOpen={{this.handleOpen}}
    @registerAPI={{this._registerAPI}}
    @renderInPlace={{@renderInPlace}}
    @verticalPosition={{@verticalPosition}}
    @disabled={{@disabled}}
    @calculatePosition={{this.calculatePosition}}
    ...attributes as |dropdown|>
    <dropdown.Trigger
      @eventType={{or @eventType "mousedown"}}
      {{on "keydown" this.handleTriggerKeydown}}
      {{on "focus" this.handleTriggerFocus}}
      {{on "blur" this.handleTriggerBlur}}
      class={{this.concatenatedTriggerClasses}}
      id={{@triggerId}}
      role={{this.triggerRole}}
      aria-describedby={{@ariaDescribedBy}}
      aria-invalid={{@ariaInvalid}}
      aria-label={{@ariaLabel}}
      aria-labelledby={{@ariaLabelledBy}}
      aria-required={{@required}}
      title={{@title}}
      tabindex={{and (not @disabled) (or @tabindex "0")}}>
      {{#let (component this.triggerComponent) as |Trigger|}}
        <Trigger
          @htmlTag={{this._triggerTagName}}
          @allowClear={{@allowClear}}
          @buildSelection={{@buildSelection}}
          @extra={{@extra}}
          @listboxId={{this.optionsId}}
          @loadingMessage={{this.loadingMessage}}
          @onFocus={{this.handleFocus}}
          @onBlur={{this.handleBlur}}
          @onInput={{this.handleInput}}
  
          @onKeydown={{this.handleKeydown}}
          @searchEnabled={{@searchEnabled}}
          @searchField={{@searchField}}
          @select={{this.publicAPI}}
          @selectedItemComponent={{@selectedItemComponent}}
          as |opt term|>
          {{yield opt term}}
        </Trigger>
      {{/let}}
    </dropdown.Trigger>
    <dropdown.Content @htmlTag={{this._contentTagName}} class={{this.concatenatedDropdownClasses}}>
      {{#let (component this.beforeOptionsComponent) as |BeforeOptions|}}
        <BeforeOptions
          @animationEnabled={{@animationEnabled}}
          @select={{this.publicAPI}}
          @searchEnabled={{@searchEnabled}}
          @searchPlaceholder={{@searchPlaceholder}}
          @listboxId={{this.optionsId}}
          @onInput={{this.handleInput}}
          @onKeydown={{this.handleKeydown}}
          @onFocus={{this.handleFocus}}
          @onBlur={{this.handleBlur}}
          @extra={{@extra}}
          @placeholder={{@placeholder}}
          @placeholderComponent={{this.placeholderComponent}}
          @selectedItemComponent={{@selectedItemComponent}}/>
      {{/let}}
      {{#if this.mustShowSearchMessage}}
        {{#let (component this.searchMessageComponent) as |SearchMessage|}}
          <SearchMessage @searchMessage={{this.searchMessage}} @select={{this.publicAPI}}/>
        {{/let}}
      {{else if this.mustShowNoMessages}}
        {{#if this.noMatchesMessage}}
          <ul class="ember-power-select-options" role="listbox">
            <li class="ember-power-select-option ember-power-select-option--no-matches-message" role="option">
              {{this.noMatchesMessage}}
            </li>
          </ul>
        {{/if}}
      {{else}}
        {{#let (component this.optionsComponent) as |Options|}}
          <Options
            @loadingMessage={{this.loadingMessage}}
            @groupIndex=""
            @extra={{@extra}}
            @select={{this.publicAPI}}
            @options={{this.publicAPI.results}}
            @optionsComponent={{Options}}
            @highlightOnHover={{this.highlightOnHover}}
            @groupComponent={{this.groupComponent}}
            id={{this.optionsId}}
            class="ember-power-select-options" as |option term|>
            {{yield option term}}
          </Options>
        {{/let}}
      {{/if}}
      {{#let (component this.afterOptionsComponent) as |AfterOptions|}}
        <AfterOptions @select={{this.publicAPI}} @extra={{@extra}}/>
      {{/let}}
    </dropdown.Content>
  </BasicDropdown> --}}
  
  */
  {
    "id": "RjHFt2BV",
    "block": "[[[8,[39,0],null,[[\"@horizontalPosition\",\"@destination\",\"@initiallyOpened\",\"@matchTriggerWidth\",\"@preventScroll\",\"@onClose\",\"@onOpen\",\"@renderInPlace\",\"@verticalPosition\",\"@disabled\",\"@calculatePosition\",\"@triggerComponent\",\"@contentComponent\"],[[30,1],[30,2],[30,3],[30,0,[\"matchTriggerWidth\"]],[28,[37,1],[[30,4],false],null],[30,0,[\"handleClose\"]],[30,0,[\"handleOpen\"]],[30,5],[30,6],[30,7],[30,8],[28,[37,2],[[30,9]],null],[28,[37,2],[[30,10]],null]]],[[\"default\"],[[[[1,\"\\n\"],[44,[[28,[37,4],[[30,11],[28,[37,5],null,[[\"selected\",\"highlighted\",\"options\",\"results\",\"resultsCount\",\"loading\",\"isActive\",\"searchText\",\"lastSearchedText\",\"actions\"],[[30,0,[\"selected\"]],[30,0,[\"highlighted\"]],[30,0,[\"options\"]],[30,0,[\"results\"]],[30,0,[\"resultsCount\"]],[30,0,[\"loading\"]],[30,0,[\"isActive\"]],[30,0,[\"searchText\"]],[30,0,[\"lastSearchedText\"]],[28,[37,4],[[30,11,[\"actions\"]],[30,0,[\"_publicAPIActions\"]]],null]]]]],null],[28,[37,6],[\"ember-power-select-options-\",[30,11,[\"uniqueId\"]]],null]],[[[1,\"    \"],[8,[30,11,[\"Trigger\"]],[[16,0,[29,[\"ember-power-select-trigger \",[30,14],[52,[30,12,[\"isActive\"]],\" ember-power-select-trigger--active\"]]]],[16,\"aria-activedescendant\",[52,[30,11,[\"isOpen\"]],[52,[51,[30,15]],[28,[37,6],[[30,12,[\"uniqueId\"]],\"-\",[30,0,[\"highlightedIndex\"]]],null]]]],[16,\"aria-controls\",[52,[51,[30,15]],[30,13]]],[16,\"aria-describedby\",[30,16]],[16,\"aria-haspopup\",[52,[51,[30,15]],\"listbox\"]],[16,\"aria-invalid\",[30,17]],[16,\"aria-label\",[30,18]],[16,\"aria-labelledby\",[30,19]],[24,\"aria-owns\",\"\"],[16,\"aria-required\",[30,20]],[16,\"role\",[28,[37,1],[[30,21],\"button\"],null]],[16,\"title\",[30,22]],[16,1,[30,23]],[16,\"tabindex\",[28,[37,9],[[28,[37,10],[[30,7]],null],[28,[37,1],[[30,24],\"0\"],null]],null]],[17,25],[4,[38,11],[[30,0,[\"_updateOptions\"]],[30,27]],null],[4,[38,12],[[30,0,[\"_updateOptions\"]],[30,27]],null],[4,[38,11],[[30,0,[\"_updateSelected\"]],[30,28]],null],[4,[38,12],[[30,0,[\"_updateSelected\"]],[30,28]],null],[4,[38,11],[[30,0,[\"_registerAPI\"]],[30,12]],null],[4,[38,12],[[30,0,[\"_registerAPI\"]],[30,12]],null],[4,[38,12],[[30,0,[\"_performSearch\"]],[30,0,[\"searchText\"]]],null],[4,[38,13],[\"keydown\",[30,0,[\"handleTriggerKeydown\"]]],null],[4,[38,13],[\"focus\",[30,0,[\"handleFocus\"]]],null],[4,[38,13],[\"blur\",[30,0,[\"handleBlur\"]]],null]],[[\"@eventType\"],[[28,[37,1],[[30,26],\"mousedown\"],null]]],[[\"default\"],[[[[1,\"\\n\"],[44,[[52,[30,29],[50,[28,[37,2],[[30,29]],null],0,null,null],[50,\"power-select/trigger\",0,null,null]]],[[[1,\"        \"],[8,[30,30],null,[[\"@allowClear\",\"@buildSelection\",\"@loadingMessage\",\"@selectedItemComponent\",\"@select\",\"@searchEnabled\",\"@searchField\",\"@onFocus\",\"@onBlur\",\"@extra\",\"@listboxId\",\"@onInput\",\"@onKeydown\",\"@placeholder\",\"@placeholderComponent\",\"@ariaActiveDescendant\"],[[30,31],[30,32],[28,[37,1],[[30,33],\"Loading options...\"],null],[28,[37,2],[[30,34]],null],[30,12],[30,15],[30,35],[30,0,[\"handleFocus\"]],[30,0,[\"handleBlur\"]],[30,36],[30,13],[30,0,[\"handleInput\"]],[30,0,[\"handleKeydown\"]],[30,37],[52,[30,38],[28,[37,2],[[30,38]],null],[50,\"power-select/placeholder\",0,null,null]],[28,[37,6],[[30,12,[\"uniqueId\"]],\"-\",[30,0,[\"highlightedIndex\"]]],null]]],[[\"default\"],[[[[1,\"\\n          \"],[18,57,[[30,39],[30,40]]],[1,\"\\n        \"]],[39,40]]]]],[1,\"\\n\"]],[30]]],[1,\"    \"]],[]]]]],[1,\"\\n    \"],[8,[30,11,[\"Content\"]],[[16,0,[29,[\"ember-power-select-dropdown\",[52,[30,12,[\"isActive\"]],\" ember-power-select-dropdown--active\"],\" \",[30,41]]]]],null,[[\"default\"],[[[[1,\"\\n\"],[41,[28,[37,16],[[30,42],null],null],[[[44,[[52,[30,42],[50,[28,[37,2],[[30,42]],null],0,null,null],[50,\"power-select/before-options\",0,null,null]]],[[[1,\"          \"],[8,[30,43],null,[[\"@select\",\"@searchEnabled\",\"@onInput\",\"@onKeydown\",\"@onFocus\",\"@onBlur\",\"@placeholder\",\"@placeholderComponent\",\"@extra\",\"@listboxId\",\"@ariaActiveDescendant\",\"@selectedItemComponent\",\"@searchPlaceholder\"],[[30,12],[30,15],[30,0,[\"handleInput\"]],[30,0,[\"handleKeydown\"]],[30,0,[\"handleFocus\"]],[30,0,[\"handleBlur\"]],[30,37],[28,[37,1],[[30,38],[50,\"power-select/placeholder\",0,null,null]],null],[30,36],[30,13],[28,[37,6],[[30,12,[\"uniqueId\"]],\"-\",[30,0,[\"highlightedIndex\"]]],null],[28,[37,2],[[30,34]],null],[30,44]]],null],[1,\"\\n\"]],[43]]]],[]],null],[41,[30,0,[\"mustShowSearchMessage\"]],[[[44,[[52,[30,45],[50,[28,[37,2],[[30,45]],null],0,null,null],[50,\"power-select/search-message\",0,null,null]]],[[[1,\"          \"],[8,[30,46],null,[[\"@searchMessage\",\"@select\"],[[30,0,[\"searchMessage\"]],[30,12]]],null],[1,\"\\n\"]],[46]]]],[]],[[[41,[30,0,[\"mustShowNoMessages\"]],[[[44,[[52,[30,47],[50,[28,[37,2],[[30,47]],null],0,null,null],[50,\"power-select/no-matches-message\",0,null,null]]],[[[1,\"          \"],[8,[30,48],null,[[\"@noMatchesMessage\",\"@select\"],[[30,0,[\"noMatchesMessage\"]],[30,12]]],null],[1,\"\\n\"]],[48]]]],[]],[[[44,[[52,[30,49],[50,[28,[37,2],[[30,49]],null],0,null,null],[50,\"power-select/options\",0,null,null]],[52,[30,50],[50,[28,[37,2],[[30,50]],null],0,null,null],[50,\"power-select/power-select-group\",0,null,null]]],[[[1,\"          \"],[8,[30,51],[[16,1,[30,13]],[24,0,\"ember-power-select-options\"]],[[\"@loadingMessage\",\"@select\",\"@options\",\"@groupIndex\",\"@optionsComponent\",\"@extra\",\"@highlightOnHover\",\"@groupComponent\"],[[28,[37,1],[[30,33],\"Loading options...\"],null],[30,12],[30,12,[\"results\"]],\"\",[30,51],[30,36],[30,0,[\"highlightOnHover\"]],[30,52]]],[[\"default\"],[[[[1,\"\\n            \"],[18,57,[[30,53],[30,54]]],[1,\"\\n          \"]],[53,54]]]]],[1,\"\\n\"]],[51,52]]],[1,\"      \"]],[]]]],[]]],[1,\"      \\n\"],[41,[30,55],[[[44,[[50,[28,[37,2],[[30,55]],null],0,null,null]],[[[1,\"          \"],[8,[30,56],null,[[\"@extra\",\"@select\"],[[30,36],[30,12]]],null],[1,\"\\n\"]],[56]]]],[]],null],[1,\"    \"]],[]]]]],[1,\"\\n\"]],[12,13]]]],[11]]]]],[1,\"\\n\"]],[\"@horizontalPosition\",\"@destination\",\"@initiallyOpened\",\"@preventScroll\",\"@renderInPlace\",\"@verticalPosition\",\"@disabled\",\"@calculatePosition\",\"@ebdTriggerComponent\",\"@ebdContentComponent\",\"dropdown\",\"publicAPI\",\"listboxId\",\"@triggerClass\",\"@searchEnabled\",\"@ariaDescribedBy\",\"@ariaInvalid\",\"@ariaLabel\",\"@ariaLabelledBy\",\"@required\",\"@triggerRole\",\"@title\",\"@triggerId\",\"@tabindex\",\"&attrs\",\"@eventType\",\"@options\",\"@selected\",\"@triggerComponent\",\"Trigger\",\"@allowClear\",\"@buildSelection\",\"@loadingMessage\",\"@selectedItemComponent\",\"@searchField\",\"@extra\",\"@placeholder\",\"@placeholderComponent\",\"opt\",\"term\",\"@dropdownClass\",\"@beforeOptionsComponent\",\"BeforeOptions\",\"@searchPlaceholder\",\"@searchMessageComponent\",\"SearchMessage\",\"@noMatchesMessageComponent\",\"NoMatchesMessage\",\"@optionsComponent\",\"@groupComponent\",\"Options\",\"Group\",\"option\",\"select\",\"@afterOptionsComponent\",\"AfterOptions\",\"&default\"],false,[\"basic-dropdown\",\"or\",\"ensure-safe-component\",\"let\",\"assign\",\"hash\",\"concat\",\"if\",\"unless\",\"and\",\"not\",\"did-insert\",\"did-update\",\"on\",\"component\",\"yield\",\"not-eq\"]]",
    "moduleName": "ember-power-select/components/power-select.hbs",
    "isStrictMode": false
  });

  const isArrayable = coll => {
    return typeof coll.toArray === 'function';
  };

  const isPromiseLike = thing => {
    return typeof thing.then === 'function';
  };

  const isPromiseProxyLike = thing => {
    return isPromiseLike(thing) && Object.hasOwnProperty.call(thing, 'content');
  };

  const isCancellablePromise = thing => {
    return typeof thing.cancel === 'function';
  };

  let PowerSelect = (_class = class PowerSelect extends _component2.default {
    // Untracked properties
    // Tracked properties
    // Lifecycle hooks
    constructor(owner, args) {
      super(owner, args);

      _defineProperty(this, "_publicAPIActions", {
        search: this._search,
        highlight: this._highlight,
        select: this._select,
        choose: this._choose,
        scrollTo: this._scrollTo
      });

      _initializerDefineProperty(this, "_resolvedOptions", _descriptor, this);

      _initializerDefineProperty(this, "_resolvedSelected", _descriptor2, this);

      _initializerDefineProperty(this, "_repeatingChar", _descriptor3, this);

      _initializerDefineProperty(this, "_expirableSearchText", _descriptor4, this);

      _initializerDefineProperty(this, "_searchResult", _descriptor5, this);

      _initializerDefineProperty(this, "isActive", _descriptor6, this);

      _initializerDefineProperty(this, "loading", _descriptor7, this);

      _initializerDefineProperty(this, "searchText", _descriptor8, this);

      _initializerDefineProperty(this, "lastSearchedText", _descriptor9, this);

      _initializerDefineProperty(this, "highlighted", _descriptor10, this);

      _defineProperty(this, "storedAPI", void 0);

      _defineProperty(this, "_lastOptionsPromise", void 0);

      _defineProperty(this, "_lastSelectedPromise", void 0);

      _defineProperty(this, "_lastSearchPromise", void 0);

      _defineProperty(this, "_filterResultsCache", {
        results: [],
        options: [],
        searchText: this.searchText
      });

      (false && !(this.args.onChange && typeof this.args.onChange === 'function') && (0, _debug.assert)('<PowerSelect> requires an `@onChange` function', this.args.onChange && typeof this.args.onChange === 'function'));
    }

    willDestroy() {
      if (this._lastSelectedPromise && isPromiseProxyLike(this._lastSelectedPromise)) {
        try {
          (0, _observers.removeObserver)(this._lastSelectedPromise, 'content', this, this._selectedObserverCallback);
        } catch {}

        this._lastSelectedPromise = undefined;
      }

      super.willDestroy.apply(this, arguments);
    } // Getters


    get highlightOnHover() {
      return this.args.highlightOnHover === undefined ? true : this.args.highlightOnHover;
    }

    get highlightedIndex() {
      let results = this.results;
      let highlighted = this.highlighted;
      return (0, _groupUtils.pathForOption)(results, highlighted);
    }

    get searchMessage() {
      return this.args.searchMessage === undefined ? 'Type to search' : this.args.searchMessage;
    }

    get noMatchesMessage() {
      return this.args.noMatchesMessage === undefined ? 'No results found' : this.args.noMatchesMessage;
    }

    get matchTriggerWidth() {
      return this.args.matchTriggerWidth === undefined ? true : this.args.matchTriggerWidth;
    }

    get mustShowSearchMessage() {
      return !this.loading && this.searchText.length === 0 && !!this.args.search && !!this.searchMessage && this.resultsCount === 0;
    }

    get mustShowNoMessages() {
      return !this.loading && this.resultsCount === 0 && (!this.args.search || this.lastSearchedText.length > 0);
    }

    get results() {
      if (this.searchText.length > 0) {
        if (this.args.search) {
          return toPlainArray(this._searchResult || this.options);
        } else {
          if (this._filterResultsCache.options === this.options && this._filterResultsCache.searchText === this.searchText) {
            // This is an optimization to avoid filtering several times, which may be a bit expensive
            // if there are many options, if neither the options nor the searchtext have changed
            return this._filterResultsCache.results;
          }

          let results = this._filter(this.options, this.searchText);

          this._filterResultsCache = {
            results,
            options: this.options,
            searchText: this.searchText
          };
          return results;
        }
      } else {
        return this.options;
      }
    }

    get options() {
      if (this._resolvedOptions) return toPlainArray(this._resolvedOptions);

      if (this.args.options) {
        return toPlainArray(this.args.options);
      } else {
        return [];
      }
    }

    get resultsCount() {
      return (0, _groupUtils.countOptions)(this.results);
    }

    get selected() {
      if (this._resolvedSelected) {
        return toPlainArray(this._resolvedSelected);
      } else if (this.args.selected && typeof this.args.selected.then !== 'function') {
        return toPlainArray(this.args.selected);
      }

      return undefined;
    } // Actions


    handleOpen(_select, e) {
      if (this.args.onOpen && this.args.onOpen(this.storedAPI, e) === false) {
        return false;
      }

      if (e) {
        if (e instanceof KeyboardEvent && e.type === 'keydown' && (e.keyCode === 38 || e.keyCode === 40)) {
          e.preventDefault();
        }
      }

      this._resetHighlighted();
    }

    handleClose(_select, e) {
      if (this.args.onClose && this.args.onClose(this.storedAPI, e) === false) {
        return false;
      }

      this._highlight(undefined);
    }

    handleInput(e) {
      if (e.target === null) return;
      let term = e.target.value;
      let correctedTerm;

      if (this.args.onInput) {
        correctedTerm = this.args.onInput(term, this.storedAPI, e);

        if (correctedTerm === false) {
          return;
        }
      }

      this._publicAPIActions.search(typeof correctedTerm === 'string' ? correctedTerm : term);
    }

    handleKeydown(e) {
      if (this.args.onKeydown && this.args.onKeydown(this.storedAPI, e) === false) {
        return false;
      }

      return this._routeKeydown(this.storedAPI, e);
    }

    handleTriggerKeydown(e) {
      if (this.args.onKeydown && this.args.onKeydown(this.storedAPI, e) === false) {
        e.stopImmediatePropagation();
        return;
      }

      if (e.ctrlKey || e.metaKey) {
        e.stopImmediatePropagation();
        return;
      }

      if (e.keyCode >= 48 && e.keyCode <= 90 || isNumpadKeyEvent(e)) {
        // Keys 0-9, a-z or numpad keys
        this.triggerTypingTask.perform(e);
      } else if (e.keyCode === 32) {
        // Space
        this._handleKeySpace(this.storedAPI, e);
      } else {
        return this._routeKeydown(this.storedAPI, e);
      }
    }

    handleFocus(event) {
      if (!this.isDestroying) {
        (0, _runloop.scheduleOnce)('actions', this, this._updateIsActive, true);
      }

      if (this.args.onFocus) {
        this.args.onFocus(this.storedAPI, event);
      }
    }

    handleBlur(event) {
      if (!this.isDestroying) {
        (0, _runloop.scheduleOnce)('actions', this, this._updateIsActive, false);
      }

      if (this.args.onBlur) {
        this.args.onBlur(this.storedAPI, event);
      }
    } // Methods


    _search(term) {
      if (this.searchText === term) return;
      this.searchText = term;

      if (!this.args.search) {
        this.lastSearchedText = term;

        this._resetHighlighted();
      }
    }

    _updateOptions() {
      if (!this.args.options) return;

      if (isPromiseLike(this.args.options)) {
        if (this._lastOptionsPromise === this.args.options) return; // promise is still the same

        let currentOptionsPromise = this.args.options;
        this._lastOptionsPromise = currentOptionsPromise;
        this.loading = true;

        this._lastOptionsPromise.then(resolvedOptions => {
          if (this._lastOptionsPromise === currentOptionsPromise) {
            this.loading = false;
            this._resolvedOptions = resolvedOptions;

            this._resetHighlighted();
          }
        }).catch(() => {
          if (this._lastOptionsPromise === currentOptionsPromise) {
            this.loading = false;
          }
        });
      } else {
        (0, _runloop.scheduleOnce)('actions', this, this._resetHighlighted);
      }
    }

    _updateHighlighted() {
      if (this.storedAPI.isOpen) {
        this._resetHighlighted();
      }
    }

    _updateSelected() {
      if (!this.args.selected) return;

      if (typeof this.args.selected.then === 'function') {
        if (this._lastSelectedPromise === this.args.selected) return; // promise is still the same

        if (this._lastSelectedPromise && isPromiseProxyLike(this._lastSelectedPromise)) {
          (0, _observers.removeObserver)(this._lastSelectedPromise, 'content', this, this._selectedObserverCallback);
        }

        let currentSelectedPromise = this.args.selected;
        currentSelectedPromise.then(() => {
          if (this.isDestroyed || this.isDestroying) return;

          if (isPromiseProxyLike(currentSelectedPromise)) {
            (0, _observers.addObserver)(currentSelectedPromise, 'content', this, this._selectedObserverCallback);
          }
        });
        this._lastSelectedPromise = currentSelectedPromise;

        this._lastSelectedPromise.then(resolvedSelected => {
          if (this._lastSelectedPromise === currentSelectedPromise) {
            this._resolvedSelected = resolvedSelected;

            this._highlight(resolvedSelected);
          }
        });
      } else {
        this._resolvedSelected = undefined; // Don't highlight args.selected array on multi-select

        if (!Array.isArray(this.args.selected)) {
          this._highlight(this.args.selected);
        }
      }
    }

    _selectedObserverCallback() {
      this._resolvedSelected = this._lastSelectedPromise;

      this._highlight(this._resolvedSelected);
    }

    _highlight(opt) {
      if (opt && (0, _object.get)(opt, 'disabled')) {
        return;
      }

      this.highlighted = opt;
    }

    _select(selected, e) {
      if (!(0, _utils.isEqual)(this.storedAPI.selected, selected)) {
        this.args.onChange(selected, this.storedAPI, e);
      }
    }

    _choose(selected, e) {
      let selection = this.args.buildSelection ? this.args.buildSelection(selected, this.storedAPI) : selected;
      this.storedAPI.actions.select(selection, e);

      if (this.args.closeOnSelect !== false) {
        this.storedAPI.actions.close(e); // return false;
      }
    }

    _scrollTo(option) {
      let select = this.storedAPI;

      if (!document || !option) {
        return;
      }

      if (this.args.scrollTo) {
        return this.args.scrollTo(option, select);
      }

      let optionsList = document.getElementById("ember-power-select-options-".concat(select.uniqueId));

      if (!optionsList) {
        return;
      }

      let index = (0, _groupUtils.indexOfOption)(select.results, option);

      if (index === -1) {
        return;
      }

      let optionElement = optionsList.querySelectorAll('[data-option-index]').item(index);

      if (!optionElement) {
        return;
      }

      let optionTopScroll = optionElement.offsetTop - optionsList.offsetTop;
      let optionBottomScroll = optionTopScroll + optionElement.offsetHeight;

      if (optionBottomScroll > optionsList.offsetHeight + optionsList.scrollTop) {
        optionsList.scrollTop = optionBottomScroll - optionsList.offsetHeight;
      } else if (optionTopScroll < optionsList.scrollTop) {
        optionsList.scrollTop = optionTopScroll;
      }
    }

    _registerAPI(_, _ref) {
      let [publicAPI] = _ref;
      this.storedAPI = publicAPI;

      if (this.args.registerAPI) {
        (0, _runloop.scheduleOnce)('actions', null, this.args.registerAPI, publicAPI);
      }
    }

    _performSearch(_, _ref2) {
      let [term] = _ref2;
      if (!this.args.search) return;

      if (term === '') {
        this.loading = false;
        this.lastSearchedText = term;

        if (this._lastSearchPromise !== undefined) {
          if (isCancellablePromise(this._lastSearchPromise)) {
            this._lastSearchPromise.cancel(); // Cancel ember-concurrency tasks

          }

          this._lastSearchPromise = undefined;
        }

        return;
      }

      let searchResult = this.args.search(term, this.storedAPI);

      if (searchResult && isPromiseLike(searchResult)) {
        this.loading = true;

        if (this._lastSearchPromise !== undefined && isCancellablePromise(this._lastSearchPromise)) {
          this._lastSearchPromise.cancel(); // Cancel ember-concurrency tasks

        }

        this._lastSearchPromise = searchResult;
        searchResult.then(results => {
          if (this._lastSearchPromise === searchResult) {
            this._searchResult = results;
            this.loading = false;
            this.lastSearchedText = term;
            (0, _runloop.scheduleOnce)('actions', this, this._resetHighlighted);
          }
        }).catch(() => {
          if (this._lastSearchPromise === searchResult) {
            this.loading = false;
            this.lastSearchedText = term;
          }
        });
      } else {
        this.lastSearchedText = term;
        this._searchResult = searchResult;
        (0, _runloop.scheduleOnce)('actions', this, this._resetHighlighted);
      }
    }

    _defaultBuildSelection(option) {
      return option;
    }

    _routeKeydown(select, e) {
      if (e.keyCode === 38 || e.keyCode === 40) {
        // Up & Down
        return this._handleKeyUpDown(select, e);
      } else if (e.keyCode === 13) {
        // ENTER
        return this._handleKeyEnter(select, e);
      } else if (e.keyCode === 9) {
        // Tab
        return this._handleKeyTab(select, e);
      } else if (e.keyCode === 27) {
        // ESC
        return this._handleKeyESC(select, e);
      }
    }

    _handleKeyTab(select, e) {
      select.actions.close(e);
    }

    _handleKeyESC(select, e) {
      select.actions.close(e);
    }

    _handleKeyEnter(select, e) {
      if (select.isOpen && select.highlighted !== undefined) {
        select.actions.choose(select.highlighted, e);
        e.stopImmediatePropagation();
        return false;
      }
    }

    _handleKeySpace(select, e) {
      if (e.target !== null && ['TEXTAREA', 'INPUT'].includes(e.target.nodeName)) {
        e.stopImmediatePropagation();
      } else if (select.isOpen && select.highlighted !== undefined) {
        e.stopImmediatePropagation();
        e.preventDefault(); // Prevents scrolling of the page.

        select.actions.choose(select.highlighted, e);
      }
    }

    _handleKeyUpDown(select, e) {
      if (select.isOpen) {
        e.preventDefault();
        e.stopPropagation();
        let step = e.keyCode === 40 ? 1 : -1;
        let newHighlighted = (0, _groupUtils.advanceSelectableOption)(select.results, select.highlighted, step);
        select.actions.highlight(newHighlighted);
        select.actions.scrollTo(newHighlighted);
      } else {
        select.actions.open(e);
      }
    }

    _resetHighlighted() {
      let highlighted;
      let defHighlighted = this.args.defaultHighlighted || _groupUtils.defaultHighlighted;

      if (typeof defHighlighted === 'function') {
        highlighted = defHighlighted({
          results: this.results,
          highlighted: this.highlighted,
          selected: this.selected
        });
      } else {
        highlighted = defHighlighted;
      }

      this._highlight(highlighted);
    }

    _filter(options, term) {
      let skipDisabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      let matcher = this.args.matcher || _groupUtils.defaultMatcher;
      let optionMatcher = getOptionMatcher(matcher, _groupUtils.defaultMatcher, this.args.searchField);
      return (0, _groupUtils.filterOptions)(options || [], term, optionMatcher, skipDisabled);
    }

    _updateIsActive(value) {
      this.isActive = value;
    }

    findWithOffset(options, term, offset) {
      let skipDisabled = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      let typeAheadOptionMatcher = getOptionMatcher(this.args.typeAheadOptionMatcher || _groupUtils.defaultTypeAheadMatcher, _groupUtils.defaultTypeAheadMatcher, this.args.searchField);
      return (0, _groupUtils.findOptionWithOffset)(options || [], term, typeAheadOptionMatcher, offset, skipDisabled);
    } // Tasks


    *triggerTypingTask(e) {
      // In general, a user doing this interaction means to have a different result.
      let searchStartOffset = 1;
      let repeatingChar = this._repeatingChar;
      let charCode = e.keyCode;

      if (isNumpadKeyEvent(e)) {
        charCode -= 48; // Adjust char code offset for Numpad key codes. Check here for numapd key code behavior: https://goo.gl/Qwc9u4
      }

      let term; // Check if user intends to cycle through results. _repeatingChar can only be the first character.

      let c = String.fromCharCode(charCode);

      if (c === this._repeatingChar) {
        term = c;
      } else {
        term = this._expirableSearchText + c;
      }

      if (term.length > 1) {
        // If the term is longer than one char, the user is in the middle of a non-cycling interaction
        // so the offset is just zero (the current selection is a valid match).
        searchStartOffset = 0;
        repeatingChar = '';
      } else {
        repeatingChar = c;
      } // When the select is open, the "selection" is just highlighted.


      if (this.storedAPI.isOpen && this.storedAPI.highlighted) {
        searchStartOffset += (0, _groupUtils.indexOfOption)(this.storedAPI.options, this.storedAPI.highlighted);
      } else if (!this.storedAPI.isOpen && this.selected) {
        searchStartOffset += (0, _groupUtils.indexOfOption)(this.storedAPI.options, this.selected);
      } else {
        searchStartOffset = 0;
      } // The char is always appended. That way, searching for words like "Aaron" will work even
      // if "Aa" would cycle through the results.


      this._expirableSearchText = this._expirableSearchText + c;
      this._repeatingChar = repeatingChar;
      let match = this.findWithOffset(this.storedAPI.options, term, searchStartOffset, true);

      if (match !== undefined) {
        if (this.storedAPI.isOpen) {
          this.storedAPI.actions.highlight(match);
          this.storedAPI.actions.scrollTo(match);
        } else {
          this.storedAPI.actions.select(match, e);
        }
      }

      yield (0, _emberConcurrency.timeout)(1000);
      this._expirableSearchText = '';
      this._repeatingChar = '';
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_resolvedOptions", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_resolvedSelected", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_repeatingChar", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_expirableSearchText", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_searchResult", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isActive", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "loading", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "searchText", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "lastSearchedText", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "highlighted", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "handleOpen", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleClose", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleInput", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeydown", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeydown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleTriggerKeydown", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleTriggerKeydown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleFocus", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleFocus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleBlur", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleBlur"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_search", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "_search"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_updateOptions", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "_updateOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_updateHighlighted", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "_updateHighlighted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_updateSelected", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "_updateSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_highlight", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "_highlight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_select", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "_select"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_choose", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "_choose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_scrollTo", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "_scrollTo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_registerAPI", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "_registerAPI"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_performSearch", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "_performSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triggerTypingTask", [_emberConcurrencyDecorators.restartableTask], Object.getOwnPropertyDescriptor(_class.prototype, "triggerTypingTask"), _class.prototype)), _class);
  _exports.default = PowerSelect;

  function getOptionMatcher(matcher, defaultMatcher, searchField) {
    if (searchField && matcher === defaultMatcher) {
      return (option, text) => matcher((0, _object.get)(option, searchField), text);
    } else {
      return (option, text) => {
        (false && !(matcher !== defaultMatcher || typeof option === 'string') && (0, _debug.assert)('<PowerSelect> If you want the default filtering to work on options that are not plain strings, you need to provide `@searchField`', matcher !== defaultMatcher || typeof option === 'string'));
        return matcher(option, text);
      };
    }
  }

  function isNumpadKeyEvent(e) {
    return e.keyCode >= 96 && e.keyCode <= 105;
  }

  const toPlainArray = collection => {
    if (isArrayable(collection)) {
      return collection.toArray();
    } else {
      return collection;
    }
  };

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PowerSelect);
});